import { memo } from 'react';

import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import NameIcon from '#client/components/NameIcon';

import { AccountWrapperV2 } from './AccountCommon.styles';

function AccountInstant({
  numberOfCharacters = 2,
  pillText,
  title,
  subtitle,
  buttonText,
  onClick,
  nameIcon,
  loading,
  disabled,
  buttonProps = {}
}) {
  return (
    <AccountWrapperV2 aria-label="account">
      <Stack
        alignItems={{ xs: 'start', md: 'center' }}
        flexDirection={{ xs: 'column', md: 'row' }}
        gap="16px"
        width="100%"
      >
        <Box display={{ xs: 'none', md: 'block' }}>
          <NameIcon
            circle
            name={nameIcon ?? title}
            numberOfCharacters={numberOfCharacters}
          />
        </Box>
        <Stack
          alignItems={{ xs: 'left', md: 'center' }}
          flexDirection={{ xs: 'column', md: 'row' }}
          flexGrow={5}
          gap="16px"
          justifyContent="space-between"
        >
          <Stack
            alignItems="start"
            gap="4px"
          >
            {pillText && (
              <Text
                color="red"
                size="xs"
              >
                {pillText}
              </Text>
            )}
            <Text
              size="md"
              weight="medium"
            >
              {title}
            </Text>
            <Text
              color="tertiary"
              size="xs"
            >
              {subtitle}
            </Text>
          </Stack>
        </Stack>
        <Box
          alignSelf={{ xs: 'start', md: 'center' }}
          width={{ xs: '100%', md: 'auto' }}
        >
          <Button
            aria-label="select-account"
            disabled={disabled}
            fullWidth
            loading={loading}
            onClick={onClick}
            role="button"
            size="small"
            sx={{ width: '100%' }}
            variant="contained"
            {...buttonProps}
          >
            {buttonText}
          </Button>
        </Box>
      </Stack>
    </AccountWrapperV2>
  );
}

AccountInstant.propTypes = {
  numberOfCharacters: PropTypes.number,
  pillText: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  nameIcon: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonProps: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

export default memo(AccountInstant);
